import { render } from "./IndexCleanup.vue?vue&type=template&id=3b711f84&scoped=true"
import script from "./IndexCleanup.vue?vue&type=script&lang=js"
export * from "./IndexCleanup.vue?vue&type=script&lang=js"

import "./IndexCleanup.vue?vue&type=style&index=0&id=3b711f84&scoped=true&lang=css"
import "./IndexCleanup.vue?vue&type=style&index=1&id=3b711f84&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b711f84"]])

export default __exports__